import { Helmet } from 'react-helmet-async';
import { BranchListView } from 'src/sections/branch/view';

export default function BranchListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Branch</title>
      </Helmet>

      <BranchListView />
    </>
  );
}
